/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faPlusSquare,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

import { Link, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { メニューコード } from "../../../constant/menuCode"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import TekiseiSindanService from "../../../service/driver/tekiseiSindan/tekiseiSindanService"
import {
  TTekiseiSindanListGetReq,
  TTekiseiSindanListGetRes,
  T適性診断一覧,
} from "../../../service/driver/tekiseiSindan/TTekiseiSindan"
import BusyoService from "../../../service/master/busyo/busyoService"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import dateUtil from "../../../ts/util/dateUtil"
import { T適性診断実施登録State } from "../TekiseiSindanZissiRegister/TekiseiSindanZissiRegister"
import stringUtil from "../../../ts/util/stringUtil"
import dayjs from "dayjs"
import { RootState } from "../../../globalStore/rootreducer"

/**
 * 適性診断一覧
 * @returns
 */
const TekiseiSindanList = () => {
  const history = useHistory()
  const location = useLocation()
  const { eigyobiStr: 営業日 } = useSelector((state: RootState) => state.date)
  const 営業年 = dayjs(営業日).year()

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "TekiseiSindanList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<T適性診断一覧>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TTekiseiSindanListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TTekiseiSindanListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new TekiseiSindanService().getList(
        currentSearchCondition
      )

      dispatch(setAlerts(res))

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = (): TTekiseiSindanListGetReq => {
    const query: TTekiseiSindanListGetReq = queryString.parse(location.search)
    set部所コード(query.部所コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TTekiseiSindanListGetReq => {
    return {
      部所コード,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TTekiseiSindanListGetReq
  ) => {
    const disp部所 = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.部所コード
    )
    return {
      部所: disp部所 ? `${disp部所.部所コード} ${disp部所.部所名}` : undefined,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set部所コード(undefined)
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        const dataItem: T適性診断一覧 = e.getRow().dataItem

        let isWarnRow = false
        if (stringUtil.isNullOrWhiteSpace(dataItem.前回実施日)) {
          isWarnRow = true
        } else {
          const 前回年 = dayjs(dataItem.前回実施日).year()
          if (4 <= 営業年 - 前回年) {
            isWarnRow = true
          }
        }

        if (isWarnRow) {
          wjCore.toggleClass(e.cell, "warn-text", true)
        }
      }
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [部所コード, set部所コード] = useState<T部所マスタ["部所コード"]>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所DataMap, set部所DataMap] = useState<wjGrid.DataMap<T部所マスタ>>()

  //#region comboboxState

  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  //#endregion

  //#endregion

  //#region [effect]

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized != null && 部所ComboBox != null) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()

        // いきなり検索
        search()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 部所ComboBox])

  useEffect(() => {
    document.title = `安全会議・健康診断一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())

    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      const 運行部所List = 部所ListRes.data.filter(
        (b) => b.運行部所フラグ === 1
      )
      set部所ItemSource(運行部所List)
      set部所DataMap(new wjGrid.DataMap(運行部所List, "部所コード", "部所略称"))
    })
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">適性診断登録</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <ComboBox.Busyo
                              placeholder="部所"
                              className="w-20rem"
                              isLoadEnded={部所isLoadEnded}
                              setIsLoadEnded={set部所isLoadEnded}
                              isAllSelect={true}
                              itemsSource={部所ItemSource}
                              selectedValue={部所コード}
                              setSelectedValue={(v) => {
                                set部所コード(v ?? undefined)
                              }}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                gridProperties={{
                  frozenColumns: 1,
                }}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                headerComponent={
                  <>
                    <Link
                      to={
                        util.getMenuPath(
                          メニューコード.乗務員管理.適性診断実施登録
                        )[0]
                      }
                      onClick={() =>
                        gridPageHelper.savePageConditionData(location.pathname)
                      }>
                      <Button disabled={isSearching}>
                        <FontAwesomeIcon icon={faPlusSquare} />
                        新規登録
                      </Button>
                    </Link>
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  binding="部所コード"
                  width={180}
                  dataMap={部所DataMap}
                  header="部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  width={100}
                  header="社員番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名"
                  width={120}
                  header="氏名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="生年月日"
                  width={120}
                  header="生年月日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TTekiseiSindanListGetRes>
                    ) => {
                      return dateUtil.format(context.item.生年月日)
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="年齢Num"
                  width={60}
                  header="年齢">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TTekiseiSindanListGetRes>
                    ) => {
                      if (context.item.年齢Num == null) return ""
                      return `${context.item.年齢Num}歳`
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="次回適正種類区分名称1"
                  width={100}
                  header="今回種類"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="前回実施日"
                  width={140}
                  header="前回実施日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TTekiseiSindanListGetRes>
                    ) => {
                      return dateUtil.format(context.item.前回実施日)
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="前回実施機関"
                  width={140}
                  header="前回実施機関"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="前回適正種類区分名称1"
                  width={100}
                  header="前回種類"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  header="実施登録"
                  allowDragging={false}
                  align="center"
                  width={100}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TTekiseiSindanListGetRes>
                    ) => {
                      const url = util.getMenuPath(
                        メニューコード.乗務員管理.適性診断実施登録
                      )[0]
                      const 画面State: T適性診断実施登録State = {
                        乗務員ID: context.item.乗務員ID,
                      }

                      return (
                        <Button
                          className="btn btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )
                            history.push(url, 画面State)
                          }}>
                          選択
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default TekiseiSindanList
